import { notificationsClient } from "@core/clients";
import { UnreadCountResponse } from "@core/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { UNREAD_COUNT_CACHE_EXPIRE_TIME_MS } from "../../config/constansts";

interface QueryParams {
  customerId: string;
}

type Options = UseQueryOptions<UnreadCountResponse, any>;

const useGetUnreadCountQuery = (config: { options?: Options; params: QueryParams }) => {
  return useQuery<UnreadCountResponse, any>(
    ["unread-count", config.params.customerId],

    async () => {
      return await notificationsClient.getUnreadCount();
    },

    {
      cacheTime: UNREAD_COUNT_CACHE_EXPIRE_TIME_MS,
      staleTime: UNREAD_COUNT_CACHE_EXPIRE_TIME_MS,
      ...config.options,
    },
  );
};

export default useGetUnreadCountQuery;
